import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle, Clock, MapPin, ArrowRight, Bike } from 'lucide-react';
import { SITE } from '../data/site';

export default function OrderConfirmation() {
  const { state } = useLocation() as { state?: { order?: any; customer?: { name?: string; email?: string } } };
  const order = state?.order;
  const customer = state?.customer;

  useEffect(() => { window.scrollTo({ top: 0, behavior: 'auto' }); }, []);

  const orderNo = order?.orderNumber || order?.number || order?._id?.toString?.().slice(-6).toUpperCase();

  return (
    <div style={{ background: 'var(--color-surface)' }} className="min-h-screen pt-32 pb-20 grid place-items-center">
      <div className="wrap max-w-xl text-center">
        <div className="mx-auto grid place-items-center w-20 h-20 rounded-full mb-6" style={{ background: 'var(--color-accent-soft)' }}>
          <CheckCircle size={40} style={{ color: 'var(--color-leaf)' }} />
        </div>
        <p className="eyebrow">Order Confirmed</p>
        <h1 className="font-display mt-2 text-ink" style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', lineHeight: 1.05 }}>
          Thank you{customer?.name ? `, ${customer.name.split(' ')[0]}` : ''}!
        </h1>
        <p className="mt-4 text-ink-2" style={{ fontSize: '1.05rem', lineHeight: 1.6 }}>
          Your order is in — we’re firing up the griddle. {customer?.email ? `A confirmation is on its way to ${customer.email}.` : ''}
        </p>

        {orderNo && (
          <div className="mt-6 inline-flex items-center gap-2 rounded-full px-4 py-2" style={{ background: 'var(--color-card-2)' }}>
            <span className="text-sm text-muted">Order</span>
            <span className="tnum font-display text-ink">#{orderNo}</span>
          </div>
        )}

        <div className="card mt-8 p-6 text-left space-y-4">
          <div className="flex items-start gap-3">
            <Clock size={20} style={{ color: 'var(--color-accent)' }} className="mt-0.5 shrink-0" />
            <div>
              <div className="font-semibold text-ink">Pickup order</div>
              <div className="text-ink-2 text-sm">We’ll have it ready shortly. Call us if you need a hand.</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <MapPin size={20} style={{ color: 'var(--color-accent)' }} className="mt-0.5 shrink-0" />
            <div>
              <div className="font-semibold text-ink">{SITE.address.line1}</div>
              <div className="text-ink-2 text-sm">{SITE.address.line2} · {SITE.phone}</div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/menu" className="btn btn-primary">Order more <ArrowRight size={16} /></Link>
          <Link to="/" className="btn btn-ghost">Back home</Link>
        </div>
      </div>
    </div>
  );
}
